import { Action } from 'redux';
import { IUser } from '../types/user';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_CODE_ERROR';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';

export interface ILoginRequestAction extends Action {
  type: typeof LOGIN_REQUEST;
  payload: {
    phone: string;
    code: string;
  };
}

export interface ILoginSuccessAction extends Action {
  type: typeof LOGIN_SUCCESS;
  payload: {
    accessToken: string;
    refreshToken: string;
    accessTokenExpiresAt: Date;
    user: IUser;
  };
}

export interface ILoginErrorAction extends Action {
  type: typeof LOGIN_ERROR;
  message: string;
}

export interface ILogoutAction extends Action {
  type: typeof LOGOUT_REQUEST;
}

export interface IChangePasswordAction extends Action {
  type: typeof CHANGE_PASSWORD_REQUEST;
  payload: {
    oldPassword: string;
    newPassword: string;
  };
}

export type ILoginAction =
  | ILoginSuccessAction
  | ILoginErrorAction
  | ILogoutAction
  | IChangePasswordAction;

export function loginRequest(phone: string, code: string): ILoginRequestAction {
  return {
    type: LOGIN_REQUEST,
    payload: {
      phone,
      code,
    },
  };
}

export function loginSuccess({
  accessToken,
  refreshToken,
  expiresAt,
  user,
}: {
  accessToken: string;
  refreshToken: string;
  expiresAt: Date;
  user: IUser;
}): ILoginSuccessAction {
  return {
    type: LOGIN_SUCCESS,
    payload: {
      accessToken,
      refreshToken,
      accessTokenExpiresAt: expiresAt,
      user,
    },
  };
}

export function loginError(message: string): ILoginErrorAction {
  return {
    type: LOGIN_ERROR,
    message,
  };
}

export function logout(): ILogoutAction {
  return {
    type: LOGOUT_REQUEST,
  };
}

export function changePassword(oldPassword: string, newPassword: string): IChangePasswordAction {
  return {
    type: CHANGE_PASSWORD_REQUEST,
    payload: {
      oldPassword: oldPassword,
      newPassword: newPassword,
    },
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/auth.ts